import { FormControl } from "@mui/material";
import { styled } from "@mui/system";

const StyledInputGrid = styled(FormControl)(({theme}) => ({
  display: "flex",
  flexDirection: "column",
  width: '100%',
  minWidth: '80px'
}));
export default StyledInputGrid;